import React, { useContext } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import Header from "../../layout/Header/Header";
import { MenuCard, MenuHeader } from "../../MenuCard";

const ITEMS = [
  { label: "Categorias",     icon: "far fa-list-alt",   color: "#3b82f6", bg: "#eff6ff", href: "/Categorias",    desc: "Categorías de gasto",     perm: "menu_gastos" },
  { label: "SubCategorias",  icon: "fas fa-list-ol",    color: "#8b5cf6", bg: "#f5f3ff", href: "/SubCategorias", desc: "Subcategorías de gasto",  perm: "menu_gastos" },
  { label: "Solicitantes",   icon: "fas fa-user",       color: "#10b981", bg: "#f0fdf4", href: "/Solicitantes",  desc: "Solicitantes autorizados", perm: "menu_gastos" },
  { label: "Gastos",         icon: "fas fa-receipt",    color: "#f97316", bg: "#fff7ed", href: "/Gastos",        desc: "Registro de gastos",       perm: "menu_gastos" },
];

function BotonesGastos() {
  const { user } = useContext(AuthContext);
  return (
    <>
      <Header />
      <div className="card container">
        <MenuHeader icon="fas fa-wallet" color="#f97316" bg="#fff7ed" title="Gastos" subtitle="Gastos operativos y catálogos" />
        {user.menu_admin ? (
          <div className="row">
            {ITEMS.map((r, i) => (
              <MenuCard key={i} {...r} enabled={!!user[r.perm]} />
            ))}
          </div>
        ) : <p style={{ color: "#94a3b8", fontSize: "0.82rem" }}>Sin acceso.</p>}
      </div>
    </>
  );
}

export default BotonesGastos;
